import t from"lodash/isEqualWith";function n(n,o){return t(n,o,(function(t,n){if("function"==typeof t&&"function"==typeof n)return!0}))}export{n as default};
